/**
 * Logo component.
 * @module components/theme/Logo/Logo
 *
 * Added logo image
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import config from '@plone/volto/registry';
import { Image } from 'semantic-ui-react';

import LogoImage from '@package/components/layout/images/logo/logo_primario_bianco.svg';

/**
 * Logo component class.
 * @function Logo
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component.
 */
const Logo = () => {
  const lang = useSelector((state) => state.intl.locale);

  return (
    <Link to={config.settings.isMultilingual ? `/${lang}` : '/'}>
      <Image src={LogoImage} alt="Visit Modena" title="Visit Modena" />
    </Link>
  );
};

export default Logo;
